export default "__VITE_ASSET__30b35088__"